import React from 'react';

const MetricsModule = ({ data, config }) => {
  const layout = config.layout || 'horizontal';

  return (
    <div className={`grid ${layout === 'horizontal' ? 'grid-cols-1 md:grid-cols-3' : 'grid-cols-1'} gap-4`}>
      {data.map((metric, index) => (
        <div key={index} className="text-center p-4 theme-bg-secondary rounded-lg">
          <div className="text-3xl font-bold text-primary-600">
            {typeof metric.value === 'object' ? JSON.stringify(metric.value) : 
             typeof metric.value === 'string' || typeof metric.value === 'number' ? metric.value : 'N/A'}
          </div>
          <div className="text-sm theme-secondary mt-1">
            {typeof metric.label === 'object' ? JSON.stringify(metric.label) : 
             typeof metric.label === 'string' || typeof metric.label === 'number' ? metric.label : 'Metric'}
          </div>
          {metric.change && (
            <div className={`text-xs mt-2 ${metric.change > 0 ? 'text-green-600' : 'theme-primary'}`}>
              {metric.change > 0 ? '↑' : '↓'} {Math.abs(metric.change)}%
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MetricsModule;
